import React from 'react';
import { Typography } from '@pw-tech/omni-ui';
import { ArrowRight } from 'lucide-react';
import Image from 'next/image';
const CourseCard = ({
  course,
  onClick
}: {
  course: any;
  onClick: () => void;
}) => {
  return <div className={`flex justify-between gap-2 transition-all duration-300 bg-white border border-gray-200 rounded-xl hover:shadow-lg hover:border-blue-100 ${!course?.isCurrent ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`} onClick={!course?.isCurrent ? undefined : onClick} data-sentry-component="CourseCard" data-sentry-source-file="CourseCard.tsx">
      <div className="flex flex-col justify-between w-1/2 h-full p-4 sm:p-6">
        <Typography variant="subHeading" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="CourseCard.tsx">
          {course?.name}
        </Typography>
        <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="CourseCard.tsx">{course?.metaData?.duration}</Typography>
        <div className="mt-2">
          <button type="button" className="py-[2px] px-2 text-white duration-200 bg-[#196CDC] rounded-xl hover:scale-110">
            <ArrowRight size={16} data-sentry-element="ArrowRight" data-sentry-source-file="CourseCard.tsx" />
          </button>
        </div>
      </div>
      <div className="relative w-2/4 h-[140px]">
        <Image src={course?.metaData?.imgUrl} alt={course?.crmProductName} fill data-sentry-element="Image" data-sentry-source-file="CourseCard.tsx" />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/50 to-transparent" />
      </div>
    </div>;
};
export default CourseCard;